type ApiBaseUrlConfig = {
  apiInternalBaseUrl: string;
  public: {
    apiBaseUrl: string;
  };
};

export const resolveApiBaseUrl = (
  config: ApiBaseUrlConfig,
  isServer: boolean,
): string =>
  isServer && config.apiInternalBaseUrl
    ? config.apiInternalBaseUrl
    : config.public.apiBaseUrl;
